var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"price-tracker",attrs:{"href":"https://tinychart.org/asset/230946361","target":"_blank"}},[_vm._v(_vm._s(_vm.price)+"$")])
}
var staticRenderFns = []

export { render, staticRenderFns }